export function getIcon(string) {
  let icon = "";
  switch (string) {
    case "E-mail":
      icon = "fas fa-envelope";
      break;
    case "Telefone":
      icon = "fas fa-phone-alt";
      break;
    case "Whatsapp":
      icon = "fab fa-whatsapp";
      break;
    case "Lista":
      icon = "fas fa-list";
      break;
    case "Endereço":
      icon = "fas fa-map-marker-alt";
      break;
    case "Usar Imagem":
      icon = null;
      break;

    default:
      icon = null;
      break;
  }

  return icon;
}
